import fraction from './mobx/center/fraction'
import { checkInTime, getOrderType, dealCheckMaterialData } from './mobx/center/cookware'
import restaurantCenter, { RESTAURANT_EVENT, Console } from './mobx/center/restaurantCenter'
import storeMobx from './mobx/store.mobx'
import productMobx from './mobx/product.mobx'
import productExtMobx from './mobx/productExt.mobx'
import productSaleMobx from './mobx/productSale.mobx'
import orderMobx from './mobx/order.mobx'
import cartMobx, { replaceCartItemPk } from './mobx/cart.mobx'
import discountMobx from './mobx/discount.mobx'
import feeMobx from './mobx/fee.mobx'
import doProductMobx from './mobx/doProduct.mobx'
import doSwapBuyMobx from './mobx/doSwapBuy.mobx'
import menuMobx from './mobx/menu.mobx'
import doComboMobx from './mobx/doCombo.mobx'
import deskMobx from './mobx/desk.mobx'
import productCenter, { convertHmsToHm } from './mobx/center/productCenter'
import orderFactory from './mobx/center/orderFactory'
import orderListMobx from './mobx/orderList.mobx'
import allMenuMobx from './mobx/allMenu.mobx'
import queueMobx from './mobx/queue.mobx'
import splitMobx from './mobx/split.mobx'
import boxFeeMobx from './mobx/boxFee.mobx'
import * as mobx from 'mobx'

const restaurantConfig = restaurantCenter.config

export const Restaurant = {
  orderListMobx,
  cartMobx,
  discountMobx,
  feeMobx,
  doProductMobx,
  doSwapBuyMobx,
  menuMobx,
  productMobx,
  productExtMobx,
  doComboMobx,
  orderMobx,
  productSaleMobx,
  deskMobx,
  productCenter,
  restaurantCenter,
  restaurantConfig,
  storeMobx,
  orderFactory,
  allMenuMobx,
  queueMobx,
  splitMobx,
  boxFeeMobx,
  getOrderType
}
export default Restaurant as any
// for export umd js or dev
(window as any).RestaurantMobx = Restaurant as any
(window as any).mobx = mobx

export {
  orderListMobx,
  cartMobx,
  discountMobx,
  feeMobx,
  doProductMobx,
  doSwapBuyMobx,
  menuMobx,
  productMobx,
  productExtMobx,
  doComboMobx,
  orderMobx,
  deskMobx,
  productSaleMobx,
  productCenter,
  restaurantCenter,
  restaurantConfig,
  storeMobx,
  orderFactory,
  allMenuMobx,
  queueMobx,
  splitMobx,
  boxFeeMobx,
  RESTAURANT_EVENT,
  Console,
  convertHmsToHm,
  fraction,
  replaceCartItemPk,
  getOrderType,
  checkInTime,
  dealCheckMaterialData
}
